module.exports = __webpack_public_path__ + "img/light-icon.ad5bf3ad.png";